import classNames from 'classnames';
import { useEffect, useRef } from 'react';

import Downfall from './Downfall';

import styles from '../../../../styles/games/downfall/downfall.module.css';

interface DownfallPixiProps {
    size?: {
        width?: number | null;
        height?: number | null;
    } | null;
    game: Game;
    options: {
        maxScore?: number;
    };
    initialPoints?: number;
    muted?: boolean;
    onHit: (points) => void;
    onEnd: (points) => void;
    className?: string | null;
}

function DownfallPixi({
    game,
    options,
    initialPoints = 0,
    muted = false,
    onHit,
    onEnd,
    size = null,
    className = null,
}: DownfallPixiProps) {
    const gameRef = useRef<HTMLDivElement>(null);
    const { width = null, height = null } = size || {};
    const application = useRef(null);

    useEffect(() => {
        if (application.current === null && width !== null && height !== null) {
            application.current = new Downfall(game, options, { initialPoints }, onHit, onEnd);
            application.current.create(gameRef, width, height).then(() => {
                application.current.init();
            });
        } else if (application.current !== null && width !== null && height !== null) {
            application.current.resize(width, height);
        }
        return () => {
            if (application.current !== null && width !== null && height !== null) {
                application.current.destroy();
                application.current = null;
            }
        };
    }, [width, height, initialPoints, onHit, onEnd]);

    useEffect(() => {
        if (application.current !== null) {
            application.current.setMuted(muted);
        }
    }, [muted]);

    return (
        <div
            className={classNames([styles.container, { [className]: className !== null }])}
            ref={gameRef}
        />
    );
}

export default DownfallPixi;
